import React, { useEffect, useState } from "react";
import VotesChart from "./components/VotesChart";
import axios from "axios";
import './index.css'
import { sortPlayerByVote } from "../../utils/sortArray";
import DefaultScreen from "../DefaultScreen";
import LoadingVoteModal from "../GoldenBallVotedScreen/components/LoadingVoteModal";

const pahseMap = {
    "nominatedPlayers": "nominate",
    "onceIdeal":"eleven",
    "goldenBall": "winner",
    "nominatedPlayersSeven": "nominate",

} 


const GraphScreen = ({phase})=>{
    const [goldenBallInfo, setGoldenBallInfo ] = useState('');
    const editionId = window.location.pathname?.split('/')?.[3]
    const isGraphicEnable = goldenBallInfo?.isEnablePhase?.[pahseMap[phase]]?.graphic
    const [isLoading, setIsLoading] = useState(false)
    console.log('isGraphicEnable', isGraphicEnable)
    
    console.log(editionId, goldenBallInfo)


        useEffect(()=>{
            if(!editionId) return;
            setIsLoading(true)
            const url = 'https://web-production-58ed.up.railway.app/api/get/goldenBallEdition'
            axios.get(url,{params:{
                id: editionId
            }}).then(res => {
                console.log('res', res)
                setGoldenBallInfo(res?.data?.goldenBall)
                setIsLoading(false)
            }).catch(e=> {
                console.log('e', e)
                setIsLoading(false)
            })
    
        },[editionId])
    if(isLoading) return <LoadingVoteModal />
    if(!isGraphicEnable) return <DefaultScreen title={`${goldenBallInfo?.name} ${goldenBallInfo?.year}`} description={'Se han termindo las votaciones pronto conoceremos a los resultados'} />
    return(
        <div style={{overflowX:'auto'}} className="graph-chart-container">
            <div className="graph-chart-container-title">
                <p>{goldenBallInfo?.name}</p>
            </div>
            {
                phase === 'goldenBall' ? (
                <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase])} position={'Mejor Jugador del año'} />

                ) : goldenBallInfo?.[phase]?.portero ? (
                    <>
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.portero)?.slice(0,15)} position={'portero'} />
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.defensa)?.slice(0,15)} position={'defensa'} />
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.medio)?.slice(0,15)} position={'medio'} />
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.delantero)?.slice(0,15)} position={'delantero'} />
                    </>
                ) : (
                    <>
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.porteros)?.slice(0,15)} position={'porteros'} />
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.defensaLateral)?.slice(0,15)} position={'laterales'} />
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.defensasCentral)?.slice(0,15)} position={'centrales'} />
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.mediocampistas)?.slice(0,15)} position={'medios'} />
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.volantes)?.slice(0,15)} position={'medios ofensivos'} />
            <VotesChart players={sortPlayerByVote(goldenBallInfo?.[phase]?.delanteros)?.slice(0,15)} position={'delanteros'} />
                    </>
                )
            }




        
        </div>
    )

}

export default GraphScreen